import { nothing } from 'lit-html';
import { html, property } from 'lit-element';
import { KatLitElement, register } from '../../shared/base';

import baseStyles from '../../shared/base/base.lit.scss';
import styles from './progressbar.lit.scss';

/**
 * @component {kat-progressbar} KatalProgressbar A progress bar shows users the progress of a finite operation, such as a download, file transfer, or installation.<br /> This component is deprecated. Use <a href="/components/progress/">Progress component</a> instead.
 * @deprecated Use Progress component instead.
 * @status Deprecated
 * @theme flo
 * @example WithoutLabel {"value": 50,"variant":"primary"}
 * @example WithLabel {"value": 20, "label": "Loading . . .","variant":"primary"}
 * @example HistogramBar {"value": 77,"variant":"secondary"}
 * @a11y {keyboard}
 * @a11y {sr}
 * @a11y {contrast}
 */
@register('kat-progressbar')
export class KatProgressbar extends KatLitElement {
  /**
   * The percentage complete of the operation. Accepts 0-100.
   * @type {string | number}
   */
  @property()
  value?: number;

  /** The text to display in the progress bar. If attribute is missing the current value will be displayed. */
  @property()
  label?: string;

  /**
   * The mode for the bar - Primary is default
   * @enum {value} primary Primary - Default
   * @enum {value} secondary Secondary
   */
  @property()
  variant = 'primary';

  static get styles() {
    return [baseStyles, styles];
  }

  _normalizedProgress() {
    let progress = parseFloat(this.value);
    if (isNaN(progress) || progress < 0) {
      progress = 0;
    }
    if (progress > 100) {
      progress = 100;
    }
    return progress;
  }

  render() {
    const progress = this._normalizedProgress();
    const label = this.label;

    const labelEl = label ? html`<div class="label">${label}</div>` : nothing;

    const progressEl = progress
      ? html`<div class="meter" style=${`width: ${progress}%`}></div>`
      : nothing;

    return html`
      ${labelEl}
      <div class="wrapper">
        <div class="bar">${progressEl}</div>
        <span class="percent">${progress}%</span>
      </div>
    `;
  }
}
